import { render, staticRenderFns } from "./tsjTestTable.vue?vue&type=template&id=58c92c01&scoped=true&"
import script from "./tsjTestTable.vue?vue&type=script&lang=js&"
export * from "./tsjTestTable.vue?vue&type=script&lang=js&"
import style0 from "./tsjTestTable.vue?vue&type=style&index=0&id=58c92c01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c92c01",
  null
  
)

export default component.exports